import React, { useState, useEffect } from "react";
import { Link, NavLink, Outlet } from "react-router-dom";
import "./Navigation.css";
import logo from "../../Assets/logoja.png";
import { VscAccount } from "react-icons/vsc";
import { IoMdCart } from "react-icons/io";

const Navigation = () => {
  const [showLinks, setShowLinks] = useState(false);
  const [showCart, setShowCart] = useState(false);
  const [cartItems, setCartItems] = useState([]);

  const toggleLinks = (e) => {
    e.preventDefault();
    setShowLinks(!showLinks);
  };

  const toggleCart = () => {
    setShowCart(!showCart);
  };

  const toggleClick = () => {
    setShowLinks(false);
  };

  const handleLogout = () => {
    localStorage.removeItem("userEmail");
    localStorage.removeItem("userPassword");
    alert("Logged out successfully!");
    window.location.reload();
  };

  const isLoggedIn = () => {
    return localStorage.getItem("userEmail") !== null;
  };

  // Load cart items from localStorage
  useEffect(() => {
    const savedCart = JSON.parse(localStorage.getItem("cart")) || [];
    setCartItems(savedCart);
  }, [showCart]);

  // Function to empty the cart
  const emptyCart = () => {
    localStorage.removeItem("cart");
    setCartItems([]);
  };

  // Function to calculate the total price
  const calculateTotalPrice = () => {
    return cartItems.reduce((total, item) => total + item.price * item.quantity, 0).toFixed(2);
  };

  return (
    <>
      <nav className="header">
        <div className="header-logo">
          <NavLink to="/" exact>
            <img src={logo} alt="logo" />
          </NavLink>
        </div>
        <div className="header-right">
          <ul className="nav-links">
            <li>
              <NavLink onClick={toggleClick} to="/" exact activeClassName="active">
                <span className="spanipar">|</span> HOME <span className="spanipar">|</span>
              </NavLink>
            </li>
            <li>
              <NavLink onClick={toggleClick} to="/services" activeClassName="active">
                SERVICES
              </NavLink>
            </li>
            <li>
              <NavLink onClick={toggleClick} to="/shop" activeClassName="active">
                <span className="spanipar">|</span> SHOP 
              </NavLink>
            </li>
            <li>
              <NavLink onClick={toggleClick} to="/reservation" activeClassName="active">
                <span className="spanipar">|</span> RESERVATION
              </NavLink>
            </li>
            <li>
              <NavLink onClick={toggleClick} to="/about" activeClassName="active">
                <span className="spanipar">|</span> ABOUT US <span className="spanipar">|</span>
              </NavLink>
            </li>
          </ul>
          <div className="auth-container">
            <div className="auth-icon">
              <IoMdCart color="white" size={30} onClick={toggleCart} />
              <VscAccount color="white" size={30} onClick={toggleLinks} />
            </div>

            {/* Cart Preview */}
            {showCart && (
              <div className="cart-preview">
                {cartItems.length > 0 ? (
                  <>
                    <ul>
                      {cartItems.map((item) => (
                        <li key={item.id}>
                          <p>{item.name}</p>
                          <p>Quantity: {item.quantity}</p>
                          <p>Price: ${item.price * item.quantity}</p>
                        </li>
                      ))}
                    </ul>
                    <p><strong>Total Price: ${calculateTotalPrice()}</strong></p>
                    <button onClick={emptyCart}>Empty Cart</button>
                  </>
                ) : (
                  <p>Your cart is empty.</p>
                )}
              </div>
            )}

            {showLinks && (
              <ul id="linqet-auth" className="auth-links">
                {isLoggedIn() ? (
                  <li>
                    <Link to="/dashboard">
                      <button onClick={toggleClick}>Dashboard</button>
                    </Link>
                    <button onClick={handleLogout}>Logout</button>
                  </li>
                ) : (
                  <>
                    <li>
                      <NavLink onClick={toggleClick} to="/login">
                        Login
                      </NavLink>
                    </li>
                    <li>
                      <NavLink onClick={toggleClick} to="/register">
                        Register
                      </NavLink>
                    </li>
                  </>
                )}
              </ul>
            )}
          </div>
        </div>
      </nav>
      <Outlet />
    </>
  );
};

export default Navigation;
